import { React, useEffect, useState, useRef } from 'react';
import { Link as RouterLink, useNavigate, useLocation, useOutletContext } from 'react-router-dom';
import { DataGrid, GridToolbar, GridPagination } from '@mui/x-data-grid';
import { alpha, styled } from '@mui/material/styles';
import FilterListIcon from '@mui/icons-material/FilterList';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import KeyboardDoubleArrowRightOutlinedIcon from '@mui/icons-material/KeyboardDoubleArrowRightOutlined';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import ArrowOutwardOutlinedIcon from '@mui/icons-material/ArrowOutwardOutlined';
// material
import {
    Card,
    IconButton,
    Stack,
    Button,
    TextField,
    Divider,
    FormControl,
    MenuItem,
    InputLabel, Select,
    Autocomplete,
    Tooltip,
    FormGroup,
    FormControlLabel,
    Checkbox,
    ListItemText,
    Grid,
    Typography, CardContent,
    Link,
    Box,
    Tabs,
    Tab,
    Badge,
    FormLabel,
    InputAdornment,
    Modal,
    Popper,
    Paper,
    ClickAwayListener,
    TextareaAutosize
} from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { startOfMonth, endOfMonth } from 'date-fns';
import { useSnackbar } from 'notistack';
import * as FileSaver from 'file-saver';
import Moment from 'moment';
import { Icon } from '@iconify/react';
import ManageSearchOutlinedIcon from '@mui/icons-material/ManageSearchOutlined';
import XLSX from 'sheetjs-style';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import InfoIcon from '@mui/icons-material/Info';
import CloseIcon from '@mui/icons-material/Close';
import StickyHeader from '../../Common/StickyHeader';
import AppCache from '../../../services/AppCache';
import Iconify from '../../Iconify';
import URLS from '../../../services/urls.service';
import LoadingProgressBar from '../../../theme/overrides/LoadingProgressBar';
import Page from '../../Page';
import { handleError } from '../../Common/Utils';
import Blog from '../../../pages/Blog'
import ServiceCards from '../../Common/ServiceCard'

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------------------------------
const ContentStyle = styled('div')(({ theme }) => ({

    margin: 'auto',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(1, 1)
}));
const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '60%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    height: '75vh',
    overflow: 'auto',
    borderRadius: '8px',
};
// ----------------------------------------------------------------------

// lives only while the tab stays open
const tmpCache = {};
const stripHtml = (html) => {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    const text = tempDiv.textContent || tempDiv.innerText || "";
    return text.replace(/\s+/g, ' ').trim(); // collapse whitespace and remove line breaks
};

export default function ServicesListing() {
    const location = useLocation();
    const { onOpenSidebar, open, onCloseSidebar, previousPath, currentPath } = useOutletContext();

    const handleFilterClick = () => {
        onOpenSidebar(); // expand sidebar if collapsed
    };
    const handleFilterCollapseClick = () => {
        console.log(">>>>>>>>>>>>>>>>>>>>>>>>>>>>")
        onCloseSidebar(); // expand sidebar if collapsed
    };
    const IssueDateDropdown = [
        { Id: 0, value: 'Issue Date' },
        { Id: 1, value: 'Appointment Date' },
        { Id: 2, value: 'Allocation Date' },
    ];
    const StatusDropdown = [
        { Id: 0, value: 'Pending' },
        { Id: 1, value: 'Closed' },
        { Id: 2, value: 'All' },
        { Id: 3, value: 'Routine' },
    ];
    const PriorityDropdown = [
        { Id: 1, value: 'High' },
        { Id: 2, value: 'Low' },
        { Id: 3, value: 'Medium' }
    ];
    const OrderByDropdown = [
        { Id: 0, value: 'Asc' },
        { Id: 1, value: 'Desc' },
    ];

    const { enqueueSnackbar } = useSnackbar();
    const navigate = useNavigate();
    const CurrentLoggedInUser = AppCache.GetCurrentLoggedInUser();
    const [pageSize, setPageSize] = useState(25);

    const userId = CurrentLoggedInUser.ExecutiveId;

    const [client, setClient] = useState(tmpCache.client ?? []);
    const [selectedClient, setSelectedClient] = useState([]);

    const [site, setSite] = useState(tmpCache.site ?? []);
    const [selectedSite, setSelectedSite] = useState([]);

    const [project, setProject] = useState(tmpCache.project ?? []);
    const [selectedProject, setSelectedProject] = useState([]);

    const [reportedBy, setReportedBy] = useState(tmpCache.reportedBy ?? '');
    const [selectedReportedBy, setSelectedReportedBy] = useState([]);

    const [ownedBy, setOwnedBy] = useState(tmpCache.ownedBy ?? '');
    const [selectedOwnedBy, setSelectedOwnedBy] = useState([]);

    const [createdBy, setCreatedBy] = useState(tmpCache.createdBy ?? '');
    const [selectedCreatedBy, setSelectedCreatedBy] = useState([]);

    const [issueId, setIssueId] = useState(tmpCache.issueId ?? "");

    const [issueCategory, setIssueCategory] = useState(tmpCache.issueCategory ?? []);
    const [selectedIssueCategory, setSelectedIssueCategory] = useState([]);

    const [issueDate, setIssueDate] = useState(tmpCache.issueDate ?? "");
    const [defaultIssueDate, setDefaultIssueDate] = useState("");

    const [effectiveFromValue, setEffectiveFromValue] = useState(tmpCache.effectiveFromValue ?? '');
    const [effectiveToValue, setEffectiveToValue] = useState(tmpCache.effectiveToValue ?? '');

    const [status, setStatus] = useState(tmpCache.status ?? 0);

    const [subStatus, setSubStatus] = useState(tmpCache.subStatus ?? []);
    const [selectedSubStatus, setSelectedSubStatus] = useState([]);

    const [priority, setPriority] = useState(tmpCache.priority ?? '');
    const [selectedPriority, setSelectedPriority] = useState([]);

    const [orderBy, setOrderBy] = useState(tmpCache.orderBy ?? '');

    const [isCheck, setIsCheck] = useState(tmpCache.isCheck ?? false);

    const [isLoading, setIsLoading] = useState(true);

    const [serviceData, setServiceData] = useState([]);
    const [editData, setEditData] = useState([]);
    const [editRCAData, setEditRCAData] = useState([]);

    const [searchIssueId, setSearchIssueId] = useState('');
    const [filteredServiceData, setFilteredServiceData] = useState(serviceData);
    const [infoModalOpen, setInfoModalOpen] = useState(false);

    const handleInfoOpen = () => setInfoModalOpen(true);
    const handleInfoClose = () => setInfoModalOpen(false);
    const isIssueDateDropdownChange = useRef(false);
    // Ref to store default values from API
    const defaultOrderRef = useRef({ issueDate: 0, orderBy: 0 });

    const clientRef = useRef(false);
    const siteRef = useRef(false);
    const projectRef = useRef(false);
    const reportedByRef = useRef(false);
    const ownedByRef = useRef(false);
    const createdByRef = useRef(false);
    const issueIdRef = useRef(false);
    const issueCategoryRef = useRef(false);
    const issueDateRef = useRef(0);
    const fromDateRef = useRef(false);
    const toDateRef = useRef(false);
    const statusRef = useRef(false);
    const subStatusRef = useRef(false);
    const priorityRef = useRef(false);
    const orderByRef = useRef(false);
    const includeOtherRef = useRef(false);

    const TABLE_HEAD = [
        { field: 'SrNo', headerName: 'Sr No', flex: 2 },
        {
            field: 'Date',
            headerName: 'Issue Date',
            flex: 10,
            renderCell: (params) => Moment(params.value).format('DD-MMM-YYYY HH:MM:SS')
        },
        {
            field: 'AppointmentDate',
            headerName: 'Appointment Date',
            flex: 12,
            renderCell: (params) => params.value ? Moment(params.value).format('DD-MMM-YYYY HH:mm:ss') : ''
        },
        {
            field: 'ClientName',
            headerName: 'Client / Site',
            flex: 15,
            valueGetter: (params) => `${params.row.ClientName} - ${params.row.Site || ''}`
        },
        { field: 'SubStatus', headerName: 'Status', flex: 8 },
        { field: 'IssueOwnedBy', headerName: 'Issue Owned By', flex: 12 },
        { field: 'Priority', headerName: 'Priority', flex: 8 },
        { field: 'IssueCategory_LastRemark', headerName: 'Last Remarks', flex: 17 },
        {
            field: 'Remarks',
            headerName: 'Remarks',
            flex: 28,
            valueGetter: (params) => `${params.row.Id} : ${params.row.Remarks}`
        },
        {
            field: 'actions',
            headerName: '',
            type: 'actions',
            flex: 5,
            headerAlign: 'right', // Align header to the right
            align: 'right', // Align content to the right
            renderCell: (cellValues) => {
                const handleMouseEnter = (e) => {
                    e.target.style.textDecoration = 'underline';
                };

                const handleMouseLeave = (e) => {
                    e.target.style.textDecoration = 'none';
                };

                return (
                    <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
                        <a
                            href="#"
                            onClick={(event) => {
                                event.preventDefault(); // Prevent default anchor behavior
                                handleClick(event, cellValues);
                            }}
                            style={{
                                color: '#337ab7',
                                textDecoration: 'none',
                                cursor: 'pointer',
                            }}
                            onMouseEnter={handleMouseEnter}
                            onMouseLeave={handleMouseLeave}
                        >
                            Service
                        </a>
                    </div>
                );
            }
        }
    ];


    const handleClient = (newValue) => {
        const clientIds = newValue.map((item) => item.ClientId);
        setClient(clientIds);
        clientRef.current = true;
    };
    const handleSite = (newValue) => {
        const siteIds = newValue.map((item) => item.SiteId);
        setSite(siteIds);
        siteRef.current = true;

    };
    const handleProject = (newValue) => {
        const projectIds = newValue.map((item) => item.ProjectId);
        setProject(projectIds);
        projectRef.current = true;

    };
    const handleReportedBy = (newValue) => {
        setReportedBy(newValue?.Id || "");
        reportedByRef.current = true;

    };
    const handleOwnedBy = (newValue) => {
        setOwnedBy(newValue?.Id || "");
        ownedByRef.current = true;

    };
    const handleCreatedBy = (newValue) => {
        setCreatedBy(newValue?.Id || "");
        createdByRef.current = true;

    };
    const handleIssueId = (e) => {
        setIssueId(e.target.value);
        issueIdRef.current = true;

    };
    const handleIssueCategory = (newValue) => {
        const categoryIds = newValue.map((item) => item.Id);
        setIssueCategory(categoryIds);
        issueCategoryRef.current = true;

    };
    const handleIssueDate = (id) => {
        isIssueDateDropdownChange.current = true;
        setIssueDate(id);
        issueDateRef.current = id;

    };
    const handleEffFrom = (newValue) => {
        setEffectiveFromValue(newValue);
        if (!effectiveToValue) {
            setEffectiveToValue(newValue);
        }
        fromDateRef.current = true;

    };

    const handleEffTo = (newValue) => {
        setEffectiveToValue(newValue);
        toDateRef.current = true;

    };

    const handleStatus = (id) => {
        setStatus(id);
        statusRef.current = true;

    };
    const handleSubStatus = (newValue) => {
        const suStatusId = newValue.map((item) => item.Id);
        setSubStatus(suStatusId);
        subStatusRef.current = true;

    };
    const handlePriority = (newValue) => {
        setPriority(newValue?.Id || "");
        priorityRef.current = true;

    };
    const handleOrderBy = (newValue) => {
        setOrderBy(newValue);
        orderByRef.current = true;

    };
    const handleCheckbox = (event) => {
        setIsCheck(event.target.checked);
        includeOtherRef.current = true;

    };

    useEffect(() => {
        URLS.getServiceEntryClientName()
            .then((response) => {
                setSelectedClient(Array.isArray(response.data) ? response.data : []);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.getServiceEntrySiteName({ ClientId: "0" })
            .then((response) => {
                setSelectedSite(Array.isArray(response.data) ? response.data : []);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.projectList()
            .then((response) => {
                setSelectedProject(Array.isArray(response.data) ? response.data : []);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.loadExecutives()
            .then((response) => {
                setSelectedReportedBy(response.data);
                setSelectedOwnedBy(response.data);
                setSelectedCreatedBy(response.data);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.loadStatusDropDown()
            .then((response) => {
                setSelectedSubStatus(response.data);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.loadIssueCategory()
            .then((response) => {
                setSelectedIssueCategory(response.data);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });
        URLS.loadPriority()
            .then((response) => {
                setSelectedPriority(Array.isArray(response.data) ? response.data : []);
            })
            .catch(error => {
                // On error
                console.log(" Error ");
            });

    }, []);


    useEffect(() => {

        URLS.getOrderByList({ LoginId: userId })
            .then((response) => {
                console.log("order>", response, response.data, response.status, Number(response.data[0].DateValue));
                if (response.status === 200 && response.data.length > 0) {
                    const defaultDate = Number(response.data[0].DateValue); // e.g. 1
                    const defaultOrder = Number(response.data[0].OrderByValue);

                    setIssueDate(defaultDate);
                    setOrderBy(defaultOrder);
                    defaultOrderRef.current = {
                        issueDate: defaultDate,
                        orderBy: defaultOrder
                    };

                    issueDateRef.current = defaultDate;
                }
            })
            .catch(error => {
                console.log("Error fetching order data", error);
            });
    }, []);
    const handleClick = (event, rowData) => {

        navigate('/dashboard/servicedetailspage', { state: { loadData: rowData } });
        console.log("************************", rowData);
    };
    useEffect(() => { tmpCache.client = client; }, [client]);
    useEffect(() => { tmpCache.site = site; }, [site]);
    useEffect(() => { tmpCache.project = project; }, [project]);
    useEffect(() => { tmpCache.reportedBy = reportedBy; }, [reportedBy]);
    useEffect(() => { tmpCache.ownedBy = ownedBy; }, [ownedBy]);
    useEffect(() => { tmpCache.createdBy = createdBy; }, [createdBy]);
    useEffect(() => { tmpCache.issueId = issueId; }, [issueId]);
    useEffect(() => { tmpCache.issueDate = issueDate; }, [issueDate]);
    useEffect(() => { tmpCache.effectiveFromValue = effectiveFromValue; }, [effectiveFromValue]);
    useEffect(() => { tmpCache.effectiveToValue = effectiveToValue; }, [effectiveToValue]);
    useEffect(() => { tmpCache.status = status; }, [status]);
    useEffect(() => { tmpCache.subStatus = subStatus; }, [subStatus]);
    useEffect(() => { tmpCache.priority = priority; }, [priority]);
    useEffect(() => { tmpCache.orderBy = orderBy; }, [orderBy]);
    useEffect(() => { tmpCache.isCheck = isCheck; }, [isCheck]);

    // Helper function to reset filters and call initial API
    const isResettingFilters = useRef(false);
    const isFirstRenderPath = useRef(true);
    const isFirstRenderMenu = useRef(true);
    const isReturningFromDetails = useRef(false);

    const onFilterClick = () => {
        setIsLoading(true);
        const payload = {
            "ClientIdList": client?.length ? client : [0],
            "SiteIdList": site?.length ? site : [0],
            "ProjectIdList": project?.length ? project : [0],
            "ExecutiveID": userId || 0,
            "ContactPersonId": Array.isArray(reportedBy) && reportedBy.length === 0 ? 0 : reportedBy,
            "frmDate": effectiveFromValue ? Moment(effectiveFromValue).format('DD-MMM-YYYY') : '',
            "toDate": effectiveToValue ? Moment(effectiveToValue).format('DD-MMM-YYYY') : '',
            "Status": status || 0,
            "IssueOwnedById": Array.isArray(ownedBy) && ownedBy.length === 0 ? "" : ownedBy,
            "Date": issueDate || 0,
            "OrderBy": orderBy === 0 ? "Asc" : "Desc" || "",
            "IncludeChilren": isCheck === false ? 0 : 1,
            "PriorityId": priority || 0,
            "SubStatusIdList": subStatus?.length ? subStatus : [0],
            "IssueCategoryIdList": issueCategory?.length ? issueCategory : [0],
            "IssueId": issueId || 0,
            "IssueCreatededById": Array.isArray(createdBy) && createdBy.length === 0 ? 0 : createdBy,
        };

        console.log("filter payload", payload)
        URLS.loadService(payload)
            .then((response) => {


                if (Array.isArray(response.data) && response.data[0]?.Error) {
                    setServiceData([]);
                    setIsLoading(false);

                    enqueueSnackbar(response.data[0].Error, { variant: 'error' });
                } else {
                    setServiceData(response.data);
                    tmpCache.serviceData = response.data;
                    tmpCache.filters = payload;
                    console.log("+++++++++++++++", response.data)
                    setIsLoading(false);
                    enqueueSnackbar("Fetched Data Successfully.", { variant: 'success' });
                }
            })
            .catch(error => {
                setServiceData([]);
                enqueueSnackbar("Data not found", { variant: 'success' });
                setIsLoading(false);

            });
    };

    useEffect(() => {
        // SKIP API if coming from details
        if (isReturningFromDetails.current) {
            isReturningFromDetails.current = false; // reset for next time
            return;
        }
        if (isResettingFilters.current) {
            // 🔹 skip API if issueDate changed due to reset
            isResettingFilters.current = false;
            return;
        }
        const isOnlyDefaults = () => {
            const norm = (arr) => (!arr || arr.length === 0 ? [0] : arr);

            return (
                JSON.stringify(norm(client)) === JSON.stringify([0]) &&
                JSON.stringify(norm(site)) === JSON.stringify([0]) &&
                JSON.stringify(norm(project)) === JSON.stringify([0]) &&
                (reportedBy === 0 || reportedBy?.length === 0) &&
                (!issueId || issueId === 0) &&
                (!status || status === 0) &&
                (!priority || priority === 0) &&
                (!ownedBy || ownedBy === 0 || ownedBy.length === 0) &&
                (!createdBy || createdBy === 0 || createdBy.length === 0) &&
                (!subStatus?.length || JSON.stringify(subStatus) === JSON.stringify([0])) &&
                (!issueCategory?.length || JSON.stringify(issueCategory) === JSON.stringify([0])) &&
                !effectiveFromValue &&
                !effectiveToValue &&
                !isCheck
            );
        };

        // ✅ Use cached data if filters exist in cache and defaults are not selected
        if (tmpCache.serviceData && tmpCache.filters && !isOnlyDefaults()) {
            setServiceData(tmpCache.serviceData);
            const f = tmpCache.filters;
            // map IDs → objects so Autocomplete can display correctly
            setClient(
                selectedClient.filter((c) => f.ClientIdList?.includes(c.ClientId))
            );
            setSite(
                selectedSite.filter((s) => f.SiteIdList?.includes(s.SiteId))
            );
            setProject(
                selectedProject.filter((p) => f.ProjectIdList?.includes(p.ProjectId))
            );

            setReportedBy(f.ContactPersonId);
            setIssueId(f.IssueId || "");
            setStatus(f.Status);
            setPriority(f.PriorityId);
            setOwnedBy(f.IssueOwnedById);
            setCreatedBy(f.IssueCreatededById);
            setSubStatus(
                selectedSubStatus.filter((s) => f.SubStatusIdList?.includes(s.Id)) // or SubStatusId
            );
            setIssueCategory(
                selectedIssueCategory.filter((c) => f.IssueCategoryIdList?.includes(c.Id)) // or IssueCategoryId
            );
            setEffectiveFromValue(f.frmDate ? new Date(f.frmDate) : null);
            setEffectiveToValue(f.toDate ? new Date(f.toDate) : null);
            // setIsCheck(f.IsCheck);
            setIsCheck(Boolean(f.IncludeChilren));
            setIsLoading(false);
            return; // ✅ skip API
        }

        // skip if issueDate empty or dropdown just changed
        if (issueDate === '' || isIssueDateDropdownChange.current) {
            isIssueDateDropdownChange.current = false;
            return;
        }

        // only call API if filters are defaults
        if (isOnlyDefaults()) {
            setIsLoading(true);

            const payload = {
                ClientIdList: client?.length ? client : [0],
                SiteIdList: site?.length ? site : [0],
                ProjectIdList: project?.length ? project : [0],
                ExecutiveID: userId || 0,
                ContactPersonId: reportedBy?.length === 0 ? 0 : reportedBy,
                frmDate: effectiveFromValue ? Moment(effectiveFromValue).format("DD-MMM-YYYY") : "",
                toDate: effectiveToValue ? Moment(effectiveToValue).format("DD-MMM-YYYY") : "",
                Status: status || 0,
                IssueOwnedById: ownedBy?.length === 0 ? "" : ownedBy,
                Date: issueDate || 0,
                OrderBy: orderBy === 0 ? "Asc" : "Desc",
                IncludeChilren: isCheck ? 1 : 0,
                PriorityId: priority || 0,
                SubStatusIdList: subStatus?.length ? subStatus : [0],
                IssueCategoryIdList: issueCategory?.length ? issueCategory : [0],
                IssueId: issueId || 0,
                IssueCreatededById: createdBy?.length === 0 ? 0 : createdBy,
            };


            console.log("API call payload (defaults only)", payload);

            URLS.loadService(payload)
                .then((response) => {
                    if (Array.isArray(response.data) && response.data[0]?.Error) {
                        setServiceData([]);
                        enqueueSnackbar(response.data[0].Error, { variant: "error" });
                    } else {
                        setServiceData(response.data);
                        tmpCache.serviceData = response.data;
                        tmpCache.filters = payload;
                        // enqueueSnackbar("Fetched Data Successfully.", { variant: "success" });
                    }
                    setIsLoading(false);
                })
                .catch(() => {
                    setServiceData([]);
                    // enqueueSnackbar("Data not found", { variant: "error" });
                    setIsLoading(false);
                });
        }
    }, [issueDate]);

    // Handle path change (previousPath/currentPath)
    useEffect(() => {
        if (isFirstRenderPath.current) {
            isFirstRenderPath.current = false;
            return; // skip first render
        }

        // Skip API call if coming back from detail page
        if (
            previousPath === '/dashboard/servicedetailspage' &&
            currentPath === '/dashboard/service/services'
        ) {
            isReturningFromDetails.current = true;
            if (tmpCache.filters) {
                isResettingFilters.current = true;
                onFilterClick();
            }
            return;
        }

        if (previousPath !== currentPath) {
            resetFiltersAndLoadDefault();
        }
    }, [previousPath, currentPath]);

    // Handle menu click / location.key change
    useEffect(() => {
        if (isFirstRenderMenu.current) {
            isFirstRenderMenu.current = false;
            return; // skip first render
        }

        resetFiltersAndLoadDefault();
    }, [location.key]);


    const resetFiltersAndLoadDefault = () => {
        isResettingFilters.current = true; // 🔹 set flag before resetting

        tmpCache.serviceData = null;
        tmpCache.filters = null;

        setClient([]);
        setSite([]);
        setProject([]);
        setReportedBy([]);
        setIssueId("");
        setStatus(0);
        setPriority(0);
        setOwnedBy([]);
        setCreatedBy([]);
        setSubStatus([]);
        setIssueCategory([]);
        setEffectiveFromValue(null);
        setEffectiveToValue(null);
        setIsCheck(false);

        setIsLoading(true);

        URLS.getOrderByList({ LoginId: userId })
            .then(response => {
                if (response.status === 200 && response.data.length > 0) {
                    const defaultDate = Number(response.data[0].DateValue);
                    const defaultOrder = Number(response.data[0].OrderByValue);

                    setIssueDate(defaultDate); // 🔹 triggers useEffect normally
                    setOrderBy(defaultOrder);

                    const payload = {
                        ClientIdList: [0],
                        SiteIdList: [0],
                        ProjectIdList: [0],
                        ExecutiveID: userId || 0,
                        ContactPersonId: 0,
                        frmDate: '',
                        toDate: '',
                        Status: 0,
                        IssueOwnedById: "",
                        Date: defaultDate || "",
                        OrderBy: defaultOrder === 0 ? "Asc" : "Desc",
                        IncludeChilren: 0,
                        PriorityId: 0,
                        SubStatusIdList: [0],
                        IssueCategoryIdList: [0],
                        IssueId: 0,
                        IssueCreatededById: 0,
                    };

                    URLS.loadService(payload)
                        .then(res => {
                            if (Array.isArray(res.data) && res.data[0]?.Error) {
                                setServiceData([]);
                                enqueueSnackbar(res.data[0].Error, { variant: 'error' });
                            } else {
                                setServiceData(res.data);
                                // enqueueSnackbar("Fetched Data Successfully.", { variant: 'success' });
                            }
                            setIsLoading(false);
                            isResettingFilters.current = false; // 🔹 reset flag after API completes
                        })
                        .catch(() => {
                            setServiceData([]);
                            // enqueueSnackbar("Data not found", { variant: 'error' });
                            setIsLoading(false);
                            isResettingFilters.current = false; // 🔹 reset flag even on error
                        });
                }
            })
            .catch(err => {
                console.log("Error fetching order data", err);
                setIsLoading(false);
                isResettingFilters.current = false;
            });
    };

    useEffect(() => {
        if (searchIssueId.trim() === '') {
            // No search → show full list
            setFilteredServiceData(serviceData);
        } else {
            const match = serviceData.find(
                (item) => String(item.Id) === searchIssueId.trim()
            );
            setFilteredServiceData(match ? [match] : []);
        }
    }, [searchIssueId, serviceData]);

    const handleReset = () => {
        setClient([]);
        setSite([]);
        setProject([]);
        setReportedBy([]);
        setOwnedBy([]);
        setCreatedBy([]);
        setIssueId("");
        setIssueCategory("");
        setEffectiveFromValue("");
        setEffectiveToValue("");
        setStatus(0);
        setSubStatus("");
        setIsCheck(false);
        setPriority("");
        /* setIssueDate(defaultOrderRef.current.issueDate); */
        setOrderBy(defaultOrderRef.current.orderBy);
    }


    console.log("serviceData", orderBy, serviceData)
    const [selectedStatus, setSelectedStatus] = useState('');
    const [statusCounts, setStatusCounts] = useState([]);



    useEffect(() => {
        if (serviceData) {
            const counts = {};

            serviceData.forEach(service => {
                const subStatus = service.SubStatus;
                counts[subStatus] = (counts[subStatus] || 0) + 1;
            });

            const formattedCounts = Object.keys(counts).map(subStatus => ({
                label: subStatus,
                count: counts[subStatus],

            }));

            formattedCounts.sort((a, b) => b.count - a.count);

            setStatusCounts(formattedCounts);

            if (formattedCounts.length > 0) {
                setSelectedStatus(formattedCounts[0].label);
            }
        }
    }, [serviceData]);

    const selectedStatusCount =
        statusCounts?.find(
            (status) => status?.label?.toLowerCase() === selectedStatus?.toLowerCase()
        )?.count ?? 0;


    const getColor = (label) => {
        switch (label) {
            case 'Allocated':
                return '#2B7FFF'; // Blue
            case 'WIP':
                return '#F0B100'; // Yellow
            case 'Resolved':
                return '#00C951'; // Green
            case 'UnAllocated':
                return '#9CA3AF'; // grey
            case 'On Hold - Client':
                return '#FF6900'; // Orange
            case 'On hold - Executive':
                return '#FB2C36'; // Red
            case 'On Hold - SAPL':
                return '#AD46FF'; // Purple
            case 'Pending For Release':
                return '#615FFF'; // Brown
            case 'To Be Validated':
                return '#FFA25F'; // Brown
            default:
                return '#bdbdbd'; // Grey fallback
        }
    };

    const exportToExcel = () => {
        const fileExtension = ".xlsx";
        const fileType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

        // Columns to exclude
        const excludeColumns = [
            "SrNo",
            "ReportedById",
            "ClientId",
            "SiteId",
            "IssueOwnedById",
            "ReportingToId",
            "IssueCategory",
            "SubstatusId",
            "ProjectVersionId",
            "ReportedById",
            "ProjectId",
            "LastAllocatedById"
        ];

        // Check if reports are available
        if (!serviceData || serviceData.length === 0) {
            enqueueSnackbar("No data available to export.", { variant: "error" });
            return;
        }

        // Prepare headers excluding unwanted columns
        const headers = Object.keys(serviceData[0]).filter(
            (key) => !excludeColumns.includes(key)
        );
        // Prepare the row data based on reports data
        const dataToExport = serviceData.map((row) =>
            headers.map((header) => {
                const cellValue = row[header];
                // Apply stripHtml if the value is a string
                return typeof cellValue === "string" ? stripHtml(cellValue) : cellValue;
            })
        );

        const dataWithHeaders = [headers, ...dataToExport]; // Combine headers with data rows
        const ws = XLSX.utils.aoa_to_sheet(dataWithHeaders); // Convert to AOA format
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] }; // Create workbook
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" }); // Write workbook to buffer
        const data = new Blob([excelBuffer], { type: fileType }); // Create a blob from the buffer

        const timestamp = Moment().format("DD-MMM-YYYY_HH-mm-ss");
        const fileName = `ServiceListing_${timestamp}${fileExtension}`; // Add dynamic name

        FileSaver.saveAs(data, fileName); // Save the file
        enqueueSnackbar("Exported Excel successfully.", { variant: "success" });
    };

    const exportToExcelStatusWiseData = () => {
        const fileExtension = ".xlsx";
        const fileType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";

        // Columns to exclude
        const excludeColumns = [
            "SrNo",
            "ReportedById",
            "ClientId",
            "SiteId",
            "IssueOwnedById",
            "ReportingToId",
            "IssueCategory",
            "SubstatusId",
            "ProjectVersionId",
            "ReportedById",
            "ProjectId",
            "LastAllocatedById"
        ];

        // ✅ Determine correct dataset
        let dataForExport = [];

        if (filteredServiceData && filteredServiceData.length > 0) {
            // Case 1: search or filter applied
            dataForExport = filteredServiceData.filter(
                item =>
                    item.SubStatus?.toLowerCase() === selectedStatus?.toLowerCase()
            );
        }

        if (dataForExport.length === 0 && serviceData && serviceData.length > 0) {
            // Case 2: no search/filter — export based on selected status
            dataForExport = serviceData.filter(
                item =>
                    item.SubStatus?.toLowerCase() === selectedStatus?.toLowerCase()
            );
        }

        if (!dataForExport || dataForExport.length === 0) {
            enqueueSnackbar("No data available to export for this status.", {
                variant: "error",
            });
            return;
        }

        // Prepare headers excluding unwanted columns
        const headers = Object.keys(dataForExport[0]).filter(
            (key) => !excludeColumns.includes(key)
        );

        const dataToExport = dataForExport.map((row) =>
            headers.map((header) => {
                const cellValue = row[header];
                return typeof cellValue === "string" ? stripHtml(cellValue) : cellValue;
            })
        );

        const dataWithHeaders = [headers, ...dataToExport];
        const ws = XLSX.utils.aoa_to_sheet(dataWithHeaders);
        const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
        const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
        const data = new Blob([excelBuffer], { type: fileType });

        // Dynamic file name
        const timestamp = Moment().format("DD-MMM-YYYY_HH-mm-ss");
        const safeStatusName = selectedStatus?.replace(/\s+/g, "_") || "All";
        const fileName = `ServiceListing_${safeStatusName}_${timestamp}${fileExtension}`;

        FileSaver.saveAs(data, fileName);

        enqueueSnackbar(`Exported File for "${selectedStatus}".`, {
            variant: "success",
        });
    };
    const acknowledgeList = [
        {
            id: "556478",
            title: "Zylemini+ (React Native)",
            subtitle: "New Feature Development",
        },
        {
            id: "527323",
            title: "Tiketic",
            subtitle: "New Feature Development",
        },
        {
            id: "558901",
            title: "Support Portal",
            subtitle: "Bug Fixes & Enhancements",
        },
    ];
    const [anchorEl, setAnchorEl] = useState(null);

    const openAcknowledgeList = Boolean(anchorEl);

    const [acknowledgeModal, setAcknowledgeModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const [tentativeDate, setTentativeDate] = useState('');
    const [tentativeTime, setTentativeTime] = useState("");
    const [timeRequrired, setTimeRequrired] = useState("");
    const [remark, setRemark] = useState("");

    const handleAcknowledgeClick = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };

    const handleAcknowledgeOpenModal = (item) => {
        setSelectedItem(item); // store the clicked item
        setAcknowledgeModal(true);
    };

    const handleAcknowledgeCloseModal = () => {
        setAcknowledgeModal(false);
        setSelectedItem(null);
    };

    const handleTentativeDate = (newValue) => {
        setTentativeDate(newValue);
    };


    const handleTentativeTime = (e) => {
        setTentativeTime(e.target.value); // Time input uses "HH:mm"
    };


    const handleTimeRequired = (e) => {
        setTimeRequrired(e.target.value);
    };

    const handleRemark = (e) => {
        setRemark(e.target.value);
    };
    const handleModalReset = () => {
        setTentativeDate("");
        setTentativeTime("");
        setTimeRequrired("");
        setRemark("");
    }
    const handleModalSave = () => {

    }
    console.log("status>>>>>>>>>>>", filteredServiceData, searchIssueId, serviceData)
    return (

        <>
            <StickyHeader
                title='Service Listing'
                // title={
                //    <Stack direction="row" alignItems="center" spacing={1}>
                //        <span>Service Listing</span>
                //        <Tooltip title="Need help?" >

                //            <InfoIcon fontSize="small" sx={{ color: "#E7000B", width: 19, height: 19 }} onClick={handleInfoOpen} />
                //        </Tooltip>

                //    </Stack>
                // }
                showButton={false}

                rightContent={
                    <Stack direction="row" spacing={2} alignItems="center" mt={'2px'}>
                        {/* <Button */}
                        {/*    variant="contained" */}
                        {/*    color="secondary" */}
                        {/*    sx={{ */}
                        {/*        "& .MuiButton-startIcon": { mr: "4px" }, */}
                        {/*        whiteSpace: "nowrap", */}
                        {/*        textTransform: "none", */}
                        {/*    }} */}
                        {/*    startIcon={<CheckCircleOutlinedIcon />} */}
                        {/*    onClick={handleAcknowledgeClick} */}
                        {/* > */}
                        {/*    Acknowledge (2) */}
                        {/* </Button> */}

                        <Tooltip title="Export To Excel">
                            <Button
                                variant="outlined"
                                sx={{
                                    borderColor: "#2e7d32",
                                    color: "#2e7d32",
                                    "& .MuiButton-startIcon": { mr: "2px" },
                                    "&:hover": {
                                        backgroundColor: "#2e7d32",
                                        color: "#FFFFFF",
                                    },
                                    whiteSpace: "nowrap",
                                    textTransform: "none",
                                }}
                                startIcon={<FileUploadOutlinedIcon />}
                                onClick={exportToExcel}
                            >
                                Export
                            </Button>
                        </Tooltip>
                    </Stack>
                }

            />
            <Popper open={openAcknowledgeList} anchorEl={anchorEl} placement="bottom-end">
                <ClickAwayListener onClickAway={() => setAnchorEl(null)}>
                    <Paper
                        elevation={4}
                        sx={{
                            mt: 1,
                            width: 340,
                            borderRadius: 2,
                            p: 1,
                        }}
                    >
                        {acknowledgeList.map((item) => (
                            <Box
                                key={item.id}
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    p: 1,
                                    borderRadius: 1,
                                    cursor: "pointer",

                                    borderBottom: item !== acknowledgeList.length - 1 ? "1px solid #F1F1F1" : "none",
                                }}
                                onClick={() => {
                                    console.log("Clicked:", item);
                                    setAnchorEl(null);
                                }}
                            >
                                <Box>
                                    <Typography fontSize={14} fontWeight={400}>
                                        <Box component="span" sx={{ color: "#155DFC" }}>
                                            {item.id}
                                        </Box>
                                        {" - "}
                                        <Box component="span" sx={{ color: "#3D3838" }}>
                                            {item.title}
                                        </Box>
                                    </Typography>

                                    <Typography fontSize={12} color="#928A8A">
                                        {item.subtitle}
                                    </Typography>
                                </Box>

                                <Box
                                    sx={{
                                        border: "1px solid #E1E5EB",
                                        borderRadius: 1,
                                        display: "flex",          // use flex for centering
                                        alignItems: "center",     // vertical center
                                        justifyContent: "center", // horizontal center
                                        width: 23,
                                        height: 23,
                                        p: 0,                     // remove internal padding
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation(); // prevent the parent Box onClick
                                        handleAcknowledgeOpenModal(item);
                                    }}
                                >
                                    <IconButton
                                        size="small"
                                        sx={{
                                            p: 0,                   // remove IconButton default padding
                                            minWidth: 0,
                                            color: '#696969'
                                        }}
                                    >
                                        <ArrowOutwardOutlinedIcon sx={{ fontSize: 12 }} />
                                    </IconButton>
                                </Box>

                            </Box>
                        ))}
                    </Paper>
                </ClickAwayListener>
            </Popper>

            <Modal open={acknowledgeModal} onClose={handleAcknowledgeCloseModal}>
                <Box
                    sx={{
                        ...modalStyle,
                        display: 'flex',
                        flexDirection: 'column',
                        overflow: 'hidden',
                    }}
                >
                    {/* Sticky Header */}
                    <Box
                        sx={{
                            position: 'sticky',
                            top: 0,
                            zIndex: 1,
                            backgroundColor: '#fff',
                            borderBottom: '1px solid #D1D5DB',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            px: 2,
                        }}
                    >
                        <Typography variant="h6" fontWeight="600">
                            Acknowledge
                        </Typography>
                        <IconButton onClick={handleAcknowledgeCloseModal}>
                            <CloseIcon />
                        </IconButton>
                    </Box>

                    {/* Scrollable Content */}
                    <Box
                        sx={{
                            display: 'flex',
                            flex: 1,
                            overflow: 'hidden',
                        }}
                    >
                        {/* Left Panel */}
                        <Box
                            sx={{
                                flex: 4.5,
                                backgroundColor: '#fff',
                                borderRight: '1px solid #E0E0E0',
                                display: 'flex',
                                flexDirection: 'column',
                                overflowY: 'auto',
                            }}
                        >
                            <Box sx={{ px: 2, py: 1 }}>
                                <Typography fontSize={14} fontWeight={500}>
                                    Issue Information
                                </Typography>
                            </Box>

                            {selectedItem && (
                                <Box sx={{ px: 3, pb: 2 }}>
                                    <Typography fontSize={12}>
                                        <Box component="span" sx={{ color: '#FC3838', fontWeight: 600 }}>
                                            {selectedItem.id}
                                        </Box>
                                        {" - "}
                                        <Box component="span" sx={{ fontWeight: 500 }}>
                                            {selectedItem.title}
                                        </Box>
                                    </Typography>

                                    <Box sx={{ mt: 1 }}>
                                        <Typography variant="caption" sx={{ color: '#8A9397', fontWeight: 500 }}>
                                            Client/Site:
                                        </Typography>
                                        <Typography variant="body2" color="text.primary">
                                            Smile Automation Pvt Ltd : Smile Automation Pvt Ltd - Mumbai
                                        </Typography>
                                    </Box>

                                    <Box sx={{ mt: 1 }}>
                                        <Typography variant="caption" sx={{ color: '#8A9397', fontWeight: 500 }}>
                                            Allocated by:
                                        </Typography>
                                        <Typography variant="body2" color="text.primary">
                                            Mansi Mane
                                        </Typography>
                                    </Box>

                                    <Box sx={{ mt: 1 }}>
                                        <Typography variant="caption" sx={{ color: '#8A9397', fontWeight: 500 }}>
                                            Last remark:
                                        </Typography>
                                        <Typography variant="body2" color="text.primary">
                                            as per discussion with harish sir explained UI to the @aditi . (15-Sep-2025 09:37)
                                        </Typography>
                                    </Box>

                                    <Box sx={{ mt: 1 }}>
                                        <Typography variant="caption" sx={{ color: '#8A9397', fontWeight: 500 }}>
                                            Issue remark:
                                        </Typography>
                                        <Typography variant="body2" color="text.primary" >
                                            We have to implement a new requirement in the Tiketic Portal to improve transparency and communication around ticket handling. Going forward, whenever a user (assignee) receives a ticket, they will be required to acknowledge it by filling out a short form.
                                        </Typography>
                                    </Box>
                                </Box>
                            )}
                        </Box>

                        {/* Right Panel: Acknowledge Form */}
                        <Box
                            sx={{
                                flex: 5.5,
                                overflowY: 'auto',
                                backgroundColor: '#fff',
                                display: 'flex',
                                flexDirection: 'column'
                            }}
                        >
                            {/* SCROLLABLE CONTENT WITH PADDING */}
                            <Box sx={{ py: 1, px: 2, flex: 1 }}>
                                <Typography fontSize={14} fontWeight={500}>
                                    Acknowledge Form
                                </Typography>

                                {/* tentative Date */}
                                <Box>
                                    {/* Date & Time Row */}
                                    <Box display="flex" alignItems="center" gap={2} mt={1}>
                                        <FormControl size="small" fullWidth sx={{ mb: 1 }}>
                                            <FormLabel>Tentative Action Date</FormLabel>
                                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                <DesktopDatePicker
                                                    inputFormat="dd/MMM/yyyy"
                                                    value={tentativeDate ? Moment(tentativeDate, 'DD-MMM-YYYY').toDate() : null}
                                                    onChange={handleTentativeDate}
                                                    renderInput={(params) => (
                                                        <TextField fullWidth size="small" {...params} error={false} />
                                                    )}
                                                />
                                            </LocalizationProvider>
                                        </FormControl>

                                        <FormControl size="small" fullWidth sx={{ mb: 1 }}>
                                            <FormLabel>Tentative Action Time</FormLabel>
                                            <TextField
                                                value={tentativeTime ? Moment(tentativeTime, 'hh:mm A').format('HH:mm') : ''}
                                                onChange={handleTentativeTime}
                                                type="time"
                                                InputLabelProps={{ shrink: true }}
                                                inputProps={{ step: 300 }}
                                                size="small"
                                                fullWidth
                                            />
                                        </FormControl>
                                    </Box>

                                    {/* Warning Text Below */}
                                    <Typography fontSize={10} fontWeight={500} color="#FF2B2B" sx={{ mb: 2 }}>
                                        Issue will move to "Acknowledgement Pending" if this deadline passes
                                    </Typography>
                                </Box>

                                {/* Occurrence */}
                                <FormControl size="small" fullWidth sx={{ mb: 2 }}>
                                    <FormLabel>Tentative Time Required</FormLabel>
                                    <TextField
                                        placeholder="Mention how often this issue occurs..."
                                        value={timeRequrired} // replace with state
                                        onChange={handleTimeRequired} // replace with handler
                                        size="small" fullWidth
                                    />
                                </FormControl>
                                <FormControl size="small" fullWidth sx={{ mb: 2 }}>
                                    <FormLabel>Remark</FormLabel>
                                    <TextareaAutosize
                                        minRows={3}
                                        placeholder="Add any comment..."
                                        value={remark} // replace with state
                                        onChange={handleRemark} // replace with handler
                                        style={{
                                            width: '100%',
                                            resize: 'none',
                                            border: '1px solid #E5E5E5',
                                            borderRadius: 4,
                                            padding: 8,
                                        }}
                                    />
                                </FormControl>
                            </Box>

                            <Box sx={{ backgroundColor: "#fff", p: 2 }}>

                                <Stack direction="row" spacing={1} justifyContent="flex-end">
                                    <Tooltip title="Reset">

                                        <Button variant="outlined" sx={{ width: '130px', height: '40px', color: '#374151' }} onClick={handleModalReset}>Reset</Button>
                                    </Tooltip >

                                    <Tooltip title="Save">
                                        <Button variant="contained" sx={{ width: '130px', height: '40px' }} onClick={handleModalSave} >Save</Button>
                                    </Tooltip >
                                </Stack>
                            </Box>

                        </Box>

                    </Box>
                </Box>
            </Modal>


            <Modal open={infoModalOpen} onClose={handleInfoClose}>
                <Box
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        width: "80%",
                        height: "85%",
                        bgcolor: "#f1f3f4",  // Google Docs light gray
                        boxShadow: 24,
                        borderRadius: "10px",
                        overflow: "hidden",
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    {/* Header */}
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            px: 2,
                            py: 1,
                            bgcolor: "white",
                            borderBottom: "1px solid #ddd",
                        }}
                    >
                        <Typography fontWeight="600">Document Preview</Typography>

                        <IconButton onClick={handleInfoClose}>
                            <CloseIcon />
                        </IconButton>
                    </Box>

                    {/* Google Docs viewer style content area */}
                    <Box
                        sx={{
                            flex: 1,
                            overflowY: "auto",
                            display: "flex",
                            justifyContent: "center",
                            py: 3,
                        }}
                    >
                        {/* Inside viewer - white document page */}
                        <Box
                            sx={{
                                width: "70%",      // makes it look like a document page
                                bgcolor: "white",
                                minHeight: "1000px",
                                boxShadow: "0 0 3px rgba(0,0,0,0.2)",
                                p: 3,
                                borderRadius: "4px",
                            }}
                        >
                            {/* Replace this with real content */}
                            <Typography variant="body1">
                                Your document content goes here.
                                You can load HTML, text, or PDF embed.
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            </Modal>

            <ContentStyle>
                <Page title="Services Listing" >

                    {!isLoading ? (

                        <Box sx={{
                            display: 'flex', gap: 2, height: '470px', px: 1.5,
                        }}>
                            {/* LEFT PANEL - STATUS TABS */}
                            <Box sx={{ width: '248px' }}>
                                <Card sx={{ py: 1.5, px: 0.5, height: '480px', overflowY: 'auto', boxShadow: 'none' }}>
                                    {statusCounts.length > 0 ? (
                                        statusCounts.map((tab) => {
                                            const isSelected = selectedStatus === tab.label;
                                            const color = getColor(tab.label);

                                            return (
                                                <Box
                                                    key={tab.label}
                                                    onClick={() => setSelectedStatus(tab.label)}
                                                    sx={{
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center',
                                                        p: '8px 12px',
                                                        mb: 1,
                                                        borderRadius: '8px',
                                                        height: '70px',
                                                        border: isSelected ? `1px solid ${color}` : '1px solid #e0e0e0',
                                                        backgroundColor: isSelected ? `${color}10` : '#fff',
                                                        cursor: 'pointer',
                                                        transition: '0.2s ease',
                                                        '&:hover': {
                                                            backgroundColor: isSelected ? `${color}10` : '#f9f9f9',
                                                        },
                                                    }}
                                                >
                                                    {/* Left side with dot + label */}
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.2 }}>
                                                        <Box
                                                            sx={{
                                                                width: 10,
                                                                height: 10,
                                                                borderRadius: '50%',
                                                                backgroundColor: color,
                                                                flexShrink: 0,
                                                            }}
                                                        />
                                                        <Typography variant="body2" sx={{ fontWeight: 500, whiteSpace: 'nowrap' }}>
                                                            {tab.label}
                                                        </Typography>
                                                    </Box>

                                                    {/* Right side count badge */}
                                                    <Box
                                                        sx={{
                                                            width: '50px',
                                                            height: '30px',
                                                            borderRadius: '8px',
                                                            boxShadow: '0px 0px 2px 0px #0000002E',
                                                            fontSize: '14px',
                                                            fontWeight: 400,
                                                            color: '#333',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            opacity: 1,
                                                            background: '#ffff'
                                                        }}
                                                    >
                                                        {tab.count}
                                                    </Box>
                                                </Box>
                                            );
                                        })

                                    ) : (
                                        <Typography variant="h6" color="error" sx={{ textAlign: 'center', mt: 2 }}>
                                            No status data
                                        </Typography>
                                    )}

                                </Card>
                            </Box>

                            {/* MIDDLE PANEL - SERVICE LISTING */}
                            <Box sx={{ flex: 1, maxWidth: "650px", minWidth: "650px", position: 'relative', display: 'flex' }}>
                                <Card sx={{ p: 2, height: '480px', borderRadius: '15px', width: "100%", border: '1px solid #E5E5E5', boxShadow: 'none' }}>
                                    {/* Header Row */}
                                    <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                                        {serviceData?.length > 0 ? (
                                            <Box display="flex" alignItems="center" gap={1}>
                                                <Box
                                                    sx={{
                                                        width: 10,
                                                        height: 10,
                                                        borderRadius: '50%',
                                                        backgroundColor: getColor(selectedStatus)
                                                    }}
                                                />
                                                <Typography variant="h7">{selectedStatus}</Typography>

                                                <Box
                                                    sx={{
                                                        width: '50px',
                                                        height: '30px',
                                                        borderRadius: '8px',
                                                        boxShadow: '0px 0px 2px 0px #0000002E',
                                                        fontSize: '14px',
                                                        fontWeight: 500,
                                                        color: '#666060',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        opacity: 1,
                                                        background: '#fff'
                                                    }}
                                                >
                                                    {selectedStatusCount}
                                                </Box>
                                            </Box>
                                        ) : (
                                            <Typography variant="h6" color="error">
                                                No Data Found
                                            </Typography>
                                        )}
                                        <Box display="flex" alignItems="center" gap={1}>
                                            <TextField
                                                size="small"
                                                placeholder="Search By Issue ID"
                                                value={searchIssueId}
                                                onChange={(e) => setSearchIssueId(e.target.value)}
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <ManageSearchOutlinedIcon sx={{ color: '#989898' }} />
                                                        </InputAdornment>
                                                    ),
                                                }}
                                                sx={{
                                                    height: 35,
                                                    '& .MuiOutlinedInput-root': {
                                                        backgroundColor: '#FFFFFF',
                                                    },
                                                    '& .MuiOutlinedInput-input': {
                                                        backgroundColor: '#FFFFFF',
                                                    },
                                                }}
                                            />
                                            <Tooltip title="Export To Excel" >

                                                <IconButton
                                                    sx={{
                                                        width: 38,
                                                        height: 35,
                                                        backgroundColor: "#FFFFFF",
                                                        border: "1px solid #E0E0E0",
                                                        borderRadius: "8px",
                                                        color: '#ABABAB',
                                                        "&:hover": {
                                                            backgroundColor: '#2E7D32', // primary color fill
                                                            color: "#fff",                                           // text white
                                                            borderColor: '1px solid #2E7D32',
                                                        },
                                                    }}
                                                    onClick={exportToExcelStatusWiseData}
                                                >
                                                    <FileDownloadOutlinedIcon sx={{ width: 20, height: 20 }} />
                                                </IconButton>
                                            </Tooltip>
                                        </Box>
                                    </Box>

                                    {/* Scrollable Service Cards Section */}
                                    <Box sx={{ height: '68vh', overflowY: 'auto' }}>

                                        <ServiceCards
                                            serviceData={filteredServiceData}
                                            handleClick={handleClick}
                                            selectedStatus={selectedStatus}
                                            variant="service"
                                        />
                                    </Box>
                                </Card>
                                {open && (
                                    <IconButton
                                        onClick={handleFilterClick}
                                        sx={{
                                            position: "absolute",
                                            top: "30px",   // fixed top
                                            left: "720px", // fixed left
                                            width: 20,
                                            height: 20,
                                            opacity: 1,
                                            p: 0,
                                            zIndex: 10,
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: '37px',
                                                height: '50px',
                                                backgroundColor: '#4682B4', // match your theme
                                                borderTopLeftRadius: '10px',
                                                borderBottomLeftRadius: '10px',
                                                borderTopRightRadius: 0,
                                                borderBottomRightRadius: 0,
                                                border: 'none',
                                            }}
                                        >
                                            <Icon icon="material-symbols:filter-arrow-right" width={24} height={24} color="#FFFFFF" />
                                        </Box>
                                    </IconButton>

                                )}
                            </Box>

                            {!open && (
                                <Box sx={{ width: '332px' }}>
                                    <Card sx={{ p: 0, height: '480px', display: 'flex', flexDirection: 'column', border: '1px solid #E5E5E5', boxShadow: 'none' }}>
                                        <Box sx={{ p: 2, borderBottom: '1px solid #eee', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                            <Typography variant="h6">Filter</Typography>
                                            <KeyboardDoubleArrowRightOutlinedIcon fontSize="small" sx={{ color: '#70747A', cursor: 'pointer' }} onClick={handleFilterCollapseClick} />
                                        </Box>
                                        <Box sx={{ flex: 1, overflowY: 'auto', px: 2, py: 1 }}>
                                            <Stack spacing={2}>
                                                <FormControl size="small" fullWidth>
                                                    <FormLabel >Issue ID</FormLabel>
                                                    <TextField
                                                        fullWidth
                                                        size="small"
                                                        value={issueId}
                                                        onChange={handleIssueId}
                                                        type="number"
                                                        placeholder="Issue Id"

                                                    />
                                                </FormControl>
                                                <FormControl size="small" fullWidth>
                                                    <FormLabel >Status</FormLabel>
                                                    <Select
                                                        size="small"
                                                        value={status} // This binds the selected value to the state (status)
                                                        onChange={(e) => handleStatus(e.target.value)} // Handle change for dropdown
                                                        MenuProps={{
                                                            PaperProps: {
                                                                sx: {
                                                                    backgroundColor: '#fbe9e7', // Set the background color here
                                                                    maxHeight: '200px',
                                                                    width: '200px', // Set the max height here
                                                                }
                                                            }
                                                        }}
                                                    >
                                                        {StatusDropdown.map((status) => (
                                                            <MenuItem key={status.Id} value={status.Id}>
                                                                {status.value}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                                <FormControl fullWidth size="small">
                                                    <FormLabel > Client</FormLabel>
                                                    <Autocomplete
                                                        multiple
                                                        fullWidth
                                                        limitTags={2}
                                                        size="small"
                                                        id="client"
                                                        value={selectedClient.filter((item) => client.includes(item.ClientId))}

                                                        onChange={(_, newValue) => handleClient(newValue)}
                                                        options={selectedClient}
                                                        getOptionLabel={(option) => option.Name || ""}
                                                        isOptionEqualToValue={(option, value) => option.ClientId === value.ClientId}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                placeholder={
                                                                    client.length === 0 ? "Select Option" : ""
                                                                }
                                                            />
                                                        )}
                                                        disableClearable

                                                    />
                                                </FormControl>
                                                <FormControl size="small" fullWidth >
                                                    <FormLabel >Site </FormLabel>
                                                    <Autocomplete
                                                        multiple
                                                        fullWidth
                                                        size="small"
                                                        id="site"
                                                        value={selectedSite.filter((item) => site.includes(item.SiteId))}
                                                        onChange={(_, newValue) => handleSite(newValue)}
                                                        options={selectedSite}
                                                        getOptionLabel={(option) => option.Name || ""}
                                                        isOptionEqualToValue={(option, value) => option.SiteId === value.SiteId}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                placeholder={
                                                                    site.length === 0 ? "Select Option" : ""
                                                                }
                                                            />
                                                        )}
                                                        limitTags={2}

                                                        disableClearable
                                                    />
                                                </FormControl>
                                                <FormControl size="small" fullWidth >
                                                    <FormLabel >Project </FormLabel>
                                                    <Autocomplete
                                                        multiple
                                                        fullWidth
                                                        size="small"
                                                        id="project"
                                                        value={selectedProject.filter((item) => project.includes(item.ProjectId))}
                                                        onChange={(_, newValue) => handleProject(newValue)}
                                                        options={selectedProject}
                                                        getOptionLabel={(option) => option.Name || ""}
                                                        isOptionEqualToValue={(option, value) => option.ProjectId === value.ProjectId}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                placeholder={
                                                                    project.length === 0 ? "Select Option" : ""
                                                                }
                                                            />
                                                        )}
                                                        limitTags={2}
                                                        disableClearable
                                                    />
                                                </FormControl>
                                                <FormControl size="small" fullWidth >
                                                    <FormLabel >Reported By </FormLabel>
                                                    <Autocomplete
                                                        fullWidth
                                                        size="small"
                                                        id="reported"
                                                        value={selectedReportedBy.find((option) => option.Id === reportedBy) || ""}
                                                        onChange={(_, newValue) => handleReportedBy(newValue)}
                                                        options={[{ Id: 0, Name: "Select" }, ...selectedReportedBy]}
                                                        getOptionLabel={(option) => option.Name || ""}
                                                        isOptionEqualToValue={(option, value) => option.Id === value.Id}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                placeholder={
                                                                    reportedBy.length === 0 ? "Select Option" : ""
                                                                }
                                                            />
                                                        )}
                                                        disableClearable
                                                    />
                                                </FormControl>
                                                <FormControl size="small" fullWidth >
                                                    <FormLabel >Owned By </FormLabel>
                                                    <Autocomplete
                                                        fullWidth
                                                        size="small"
                                                        id="owned"
                                                        value={selectedOwnedBy.find((option) => option.Id === ownedBy) || ""}
                                                        onChange={(_, newValue) => handleOwnedBy(newValue)}
                                                        options={[{ Id: 0, Name: "Select" }, ...selectedOwnedBy]}
                                                        getOptionLabel={(option) => option.Name || ""}
                                                        isOptionEqualToValue={(option, value) => option.Id === value.Id}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                placeholder={
                                                                    ownedBy.length === 0 ? "Select Option" : ""
                                                                }
                                                            />
                                                        )}
                                                        disableClearable
                                                    />
                                                </FormControl>
                                                <FormControl size="small" fullWidth >
                                                    <FormLabel >Created By </FormLabel>
                                                    <Autocomplete
                                                        fullWidth
                                                        size="small"
                                                        id="created"
                                                        value={selectedCreatedBy.find((option) => option.Id === createdBy) || ""}
                                                        onChange={(_, newValue) => handleCreatedBy(newValue)}
                                                        options={[{ Id: 0, Name: "Select" }, ...selectedCreatedBy]}
                                                        getOptionLabel={(option) => option.Name || ""}
                                                        isOptionEqualToValue={(option, value) => option.Id === value.Id}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                placeholder={
                                                                    createdBy.length === 0 ? "Select Option" : ""
                                                                }
                                                            />
                                                        )}
                                                        disableClearable
                                                    />
                                                </FormControl>

                                                <FormControl size="small" fullWidth>
                                                    <FormLabel >Issue Category</FormLabel>
                                                    <Autocomplete
                                                        fullWidth
                                                        multiple
                                                        size="small"
                                                        id="category"
                                                        label="Issue Category"
                                                        value={selectedIssueCategory.filter((item) => issueCategory.includes(item.Id))}
                                                        onChange={(_, newValue) => handleIssueCategory(newValue)}
                                                        options={selectedIssueCategory}
                                                        getOptionLabel={(option) => option.Name || ""}
                                                        isOptionEqualToValue={(option, value) => option.Id === value.Id}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                placeholder={
                                                                    issueCategory.length === 0 ? "Select Option" : ""
                                                                }
                                                            />
                                                        )}
                                                        disableClearable
                                                    />
                                                </FormControl>
                                                <FormControl size="small" fullWidth>
                                                    <FormLabel >Issue Date</FormLabel>
                                                    <Select

                                                        size="small"
                                                        value={issueDate}
                                                        MenuProps={{
                                                            PaperProps: {
                                                                sx: {
                                                                    backgroundColor: '#fbe9e7', // Set the background color here
                                                                    maxHeight: '200px',
                                                                    width: '200px',// Set the max height here
                                                                }
                                                            }
                                                        }}
                                                    >
                                                        <MenuItem key={-1} value={""} onClick={() => handleIssueDate()} >Select</MenuItem>

                                                        {IssueDateDropdown.map((issueDate) => (
                                                            <MenuItem key={issueDate.Id} value={issueDate.Id} onClick={() => handleIssueDate(issueDate.Id)}> {issueDate.value}</MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                                <Box display="flex" alignItems="center" gap={2}>
                                                    <FormControl size="small" fullWidth>
                                                        <FormLabel >From Date</FormLabel>
                                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                            <DesktopDatePicker
                                                                inputFormat="dd/MMM/yyyy"
                                                                value={effectiveFromValue ? Moment(effectiveFromValue, 'DD-MMM-YYYY').toDate() : null}
                                                                onChange={handleEffFrom}
                                                                renderInput={(params) => <TextField fullWidth size="small" {...params} error={false} />}
                                                            />
                                                        </LocalizationProvider>
                                                    </FormControl>
                                                    <FormControl size="small" fullWidth>
                                                        <FormLabel >To Date</FormLabel>
                                                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                                                            <DesktopDatePicker

                                                                inputFormat="dd/MMM/yyyy"
                                                                value={effectiveToValue ? Moment(effectiveToValue, 'DD-MMM-YYYY').toDate() : null}
                                                                onChange={handleEffTo}
                                                                renderInput={(params) => <TextField fullWidth size="small" {...params} error={false} />}
                                                            />
                                                        </LocalizationProvider>
                                                    </FormControl>
                                                </Box>

                                                <FormControl size="small" fullWidth>
                                                    <FormLabel >Sub Status</FormLabel>

                                                    <Autocomplete
                                                        fullWidth
                                                        multiple
                                                        size="small"
                                                        id="subStatus"
                                                        value={selectedSubStatus.filter((item) => subStatus.includes(item.Id))}
                                                        onChange={(_, newValue) => handleSubStatus(newValue)}
                                                        options={selectedSubStatus}
                                                        getOptionLabel={(option) => option.Name || ""}
                                                        isOptionEqualToValue={(option, value) => option.Id === value.Id}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                placeholder={
                                                                    subStatus.length === 0 ? "Select Option" : ""
                                                                }
                                                            />
                                                        )}
                                                        limitTags={2}
                                                        disableClearable
                                                    />
                                                </FormControl>
                                                <FormControl size="small" fullWidth>
                                                    <FormLabel >Priority</FormLabel>
                                                    <Autocomplete
                                                        fullWidth

                                                        size="small"
                                                        id="Priority"
                                                        value={selectedPriority.find((option) => option.Id === priority) || ""}
                                                        onChange={(_, newValue) => handlePriority(newValue)}
                                                        options={selectedPriority}
                                                        getOptionLabel={(option) => option.Name || ""}
                                                        isOptionEqualToValue={(option, value) => option.Id === value.Id}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                placeholder="Select Option"
                                                            />
                                                        )}
                                                        limitTags={2}
                                                        disableClearable
                                                    />

                                                </FormControl>
                                                <FormControl size="small" fullWidth>
                                                    <FormLabel >Order By</FormLabel>
                                                    <Select
                                                        size="small"
                                                        value={orderBy}
                                                        MenuProps={{
                                                            PaperProps: {
                                                                sx: {
                                                                    backgroundColor: '#fbe9e7',
                                                                    maxHeight: '200px',
                                                                    width: '200px',
                                                                },
                                                            },
                                                        }}
                                                        onChange={(e) => handleOrderBy(e.target.value)}
                                                    >
                                                        {OrderByDropdown.map((act) => (
                                                            <MenuItem key={act.Id} value={act.Id}>
                                                                {act.value}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>

                                                </FormControl>
                                                <FormGroup>
                                                    <FormControlLabel

                                                        control={<Checkbox checked={isCheck} onChange={handleCheckbox} />}
                                                        label="Include Others"
                                                    />
                                                </FormGroup>

                                            </Stack>
                                        </Box>
                                        <Box sx={{ p: 2, borderTop: '1px solid #eee' }}>
                                            <Stack direction="row" spacing={1} justifyContent="center">
                                                <Tooltip title="Reset">

                                                    <Button variant="outlined" sx={{ width: '145px', height: '42px', color: '#374151' }} onClick={handleReset}>Reset</Button>
                                                </Tooltip >

                                                <Tooltip title="Filter">
                                                    <Button variant="contained" sx={{ width: '145px', height: '42px' }} onClick={onFilterClick}>Apply</Button>
                                                </Tooltip >
                                            </Stack>
                                        </Box>

                                    </Card>
                                </Box>

                            )}

                            {/* RIGHT PANEL - FILTERS */}

                        </Box>
                    ) : (
                        <Box sx={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <LoadingProgressBar />
                        </Box>
                    )}

                </Page>
            </ContentStyle>

        </>

    );
}